import {
    RxDocument,
    RxJsonSchema
} from 'rxdb';
import { Stage } from '../models';

export type StageDoc = RxDocument<Stage, {}>

export const stageSchema: RxJsonSchema<Stage> = {
    title: 'stage schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        name: {
            type: 'string',
            primary: true
        },
        description: { type: ['string','null'] },
        updatedAt: { type: 'number' }
    }
};


const stageFields = [ 'name', 'description', 'updatedAt', 'deleted' ]


export const stagePullQueryBuilder = () => {

    const query = 'query FeedForRxdbStages($lastId: String!, $minUpdatedAt: Float! ){ '+
        'feedForRxdbStages(lastId: $lastId, minUpdatedAt: $minUpdatedAt ) { name, description, updatedAt, deleted, _rev}}';

    return (doc : Stage) => {
        const rtn = {
            query,
            variables: {
                lastId: !doc ? '' : doc.name,
                minUpdatedAt: !doc ? 0 : doc.updatedAt
            }
        };
        //console.log(`stagePullQueryBuilder() updatedAt=${doc?.updatedAt}`);console.dir(rtn)
        return rtn
    };
};


export const graphQLGenerationInput = {
    allPoints: {
        schema: stageSchema,
        feedKeys: [
            'name',
            'updatedAt'
        ],
        deletedFlag: 'deleted'
    }
}